module.exports = __webpack_public_path__ + "assets/img/logo.57945a5d.png";